import immutableUpdate from 'immutable-update'
import React, {
  useEffect,
  useState
} from 'react'
import { domToReact } from 'html-react-parser'
import { 
  Form,
  Button
} from 'antd'
import { useParams } from 'react-router-dom'
import { 
  useEventData 
} from 'data/hooks'

export const Survey = props => {

  const gameId = useParams().gameId || playmotiv.game.gameId
  const { eventId } = useParams()
  const eventData = useEventData(gameId, eventId)
  const [ form ] = Form.useForm()
  const [ saved, setSaved ] = useState(true)  
  const blockid = props.attribs['data-blockid']
  
  const onValuesChange = () => setSaved(false)
  const onFinishFailed = ({ errorFields }) => form.scrollToField(errorFields[0].name)

  const saveForm = (values) => {

    const keys = Object.keys(values)
    const keypercent = 1 / keys.length
    const progress = keys
    .reduce((percent, key) => {

      if(values[key]) {

        percent += keypercent
      }

      return percent

    }, 0)

    const evaluable = props.attribs['data-evaluable'] === 'true'
    const newValues = immutableUpdate(
      eventData.instance.eventData,
      {
        [blockid]: values
      },
      [blockid]
    )

    eventData.saveEventData(
      JSON.stringify(newValues), 
      evaluable ? progress.toFixed(2) : 0
    )
  }

  useEffect(() => {

    if(eventData) {
      
      if(eventData.instance?.eventData) {
        
        form.setFieldsValue(eventData.instance.eventData[blockid])
      }

      form.eventData = eventData
    }

  }, [eventData])

  return <Form
    form={ form }
    { ...props.attribs }
    className={ props.attribs.class }
    name={ props.attribs['data-blockid'] }
    onValuesChange={ onValuesChange }
    onFinish={saveForm}
    onFinishFailed={onFinishFailed}
  >
    { 
      domToReact(
        props.children, 
        { 
          replace: props.replace
        }
      ) 
    }
    {
      <div className="SaveForm">
        {
          !eventData?.instance.closed &&
          <Button 
            className="Save"
            type="primary"
            htmlType="submit" 
            disabled={ saved } 
          >
            Guardar
          </Button>
        }
      </div>
    }
  </Form>
}
